(() => {
  const MODAL_ID = 'lane-newsletter-modal';
  const TRIGGER_SELECTOR = '[data-lane-newsletter-trigger], a[href="#lane-newsletter-modal"]';
  const CLOSE_SELECTOR = '[data-lane-newsletter-close]';

  let lastFocusedElement = null;

  const getModal = () => document.getElementById(MODAL_ID);

  const getFocusableElements = (modal) =>
    Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => !element.hasAttribute('hidden'));

  const openModal = () => {
    const modal = getModal();
    if (!modal || !modal.hidden) return;

    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lane-newsletter-modal-open');
    modal.querySelector('.lane-newsletter-modal__panel')?.focus();
  };

  const closeModal = () => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lane-newsletter-modal-open');

    if (lastFocusedElement instanceof HTMLElement) {
      lastFocusedElement.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      openModal();
      return;
    }

    if (event.target.closest(CLOSE_SELECTOR)) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements(modal);
    if (focusableElements.length === 0) {
      event.preventDefault();
      modal.querySelector('.lane-newsletter-modal__panel')?.focus();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash === `#${MODAL_ID}`) openModal();
  });

  if (window.location.hash === `#${MODAL_ID}`) {
    openModal();
  }
})();
